/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PeriodSearchCriteriaModel} from '../../models/period/period-search-criteria/period-search-criteria.model';
import {QueryChipModel} from '../../../shared/global-search-criteria/query-chips-area/models/query-chip.model';
import {CriterionCodeEnum} from '../configuration/criterion-code.enum';
import {CriterionBaseModel} from '../../models/criterion-base/criterion-base.model';
import {BundleDynamicCriteriaEnum} from '../data/bundle-dynamic-criteria.enum';
import {DateCriterionModel} from '../../models/date-criterion/date-criterion.model';
import {QuantityCriterionModel} from '../../models/quantity-criterion/quantity-criterion.model';

export class GlobalSearchCriteriaApplyMapper {

    static fromQueryChipModelArrayToPeriodSearchCriteriaModel(queryChips: QueryChipModel[],
                                                              periodSearchCriteria: PeriodSearchCriteriaModel): PeriodSearchCriteriaModel {
        queryChips?.forEach((chip) => {
            const updatedPeriodSearchCriteria: PeriodSearchCriteriaModel =
                    GlobalSearchCriteriaApplyMapper.fromQueryChipModelToPeriodSearchCriteriaModel(chip, periodSearchCriteria);

            this.getDynamicPeriodSearchCriteria(chip, updatedPeriodSearchCriteria);

            periodSearchCriteria = updatedPeriodSearchCriteria;
        });

        return periodSearchCriteria;
    }

    static fromQueryChipModelToPeriodSearchCriteriaModel(chip: QueryChipModel, periodSearchCriteria: PeriodSearchCriteriaModel):
            PeriodSearchCriteriaModel {

        const criterionCode = chip?.filter?.criterion;
        const criterionValue = chip?.formattedValue;

        switch (criterionCode) {
            case CriterionCodeEnum.COMPLAINT_NUMBER:
                periodSearchCriteria.complaintCode = criterionValue;
                break;
            case CriterionCodeEnum.SETTLEMENT_NUMBER:
                periodSearchCriteria.settlementCode = criterionValue;
                break;
            case CriterionCodeEnum.BUNDLE_NUMBER:
                periodSearchCriteria.bundleNumber = criterionValue;
                break;
            case CriterionCodeEnum.TIME_PERIOD:
                const date: DateCriterionModel = chip?.value;
                periodSearchCriteria.periodDateCriteria = {
                    startDate: date.startDate,
                    endDate: date.endDate
                };
                break;
            case CriterionCodeEnum.PERIOD_TOTAL_AMOUNT:
                const periodTotalAmount: QuantityCriterionModel = chip?.value as QuantityCriterionModel;
                periodSearchCriteria.periodTotalAmount = {
                    biggerThan: periodTotalAmount.biggerThan,
                    lesserThan: periodTotalAmount.lesserThan
                };
                break;
            case CriterionCodeEnum.SETTLEMENT_TOTAL_AMOUNT:
                const settlementTotalAmount: QuantityCriterionModel = chip?.value as QuantityCriterionModel;
                periodSearchCriteria.settlementTotalAmount = {
                    biggerThan: settlementTotalAmount.biggerThan,
                    lesserThan: settlementTotalAmount.lesserThan
                };
                break;
            case CriterionCodeEnum.PERIOD_TYPE:
                const periodTypeCodes: string[] = chip?.value as string[];
                periodSearchCriteria.periodTypeCodes = periodTypeCodes;
                break;
            case CriterionCodeEnum.BUNDLE_STATUS:
                const bundleStatusCodes: string[] = chip?.value as string[];
                periodSearchCriteria.bundleStatusCodes = bundleStatusCodes;
                break;
            case CriterionCodeEnum.SUPPLIER:
                periodSearchCriteria.supplierCodes =  chip?.value as string[];
                break;
            default:
                break;
        }

        return periodSearchCriteria;
    }

    static fromQueryChipModelToCriterionBaseModel(chip: QueryChipModel, periodSearchCriteriaValue: CriterionBaseModel[]):
            CriterionBaseModel[] {
        let result: CriterionBaseModel[] = [];
        const criterionCode = chip?.filter?.criterion;
        const criterionValue = chip?.formattedValue;

        if (periodSearchCriteriaValue != null) {
            const criterionBase: CriterionBaseModel = {
                specCode: criterionCode,
                value: criterionValue
            };
            result = periodSearchCriteriaValue;
            result.push(criterionBase);
        } else {
            result.push({
                specCode: criterionCode,
                value: criterionValue
            });
        }
        return result;
    }

    static getDynamicPeriodSearchCriteria(chip: QueryChipModel, periodSearchCriteria: PeriodSearchCriteriaModel): void {
        const dynamicCriterion = chip?.filter?.criterionDynamicContext;

        switch (dynamicCriterion) {
            case BundleDynamicCriteriaEnum.BUNDLE_CRITERIA_SPEC:
                periodSearchCriteria.bundleCriteria =
                        this.fromQueryChipModelToCriterionBaseModel(chip, periodSearchCriteria.bundleCriteria);
                break;
            case BundleDynamicCriteriaEnum.BUNDLE_POSITION_CRITERIA_SPEC:
                periodSearchCriteria.bundlePositionCriteria =
                        this.fromQueryChipModelToCriterionBaseModel(chip, periodSearchCriteria.bundlePositionCriteria);
                break;
            default:
                break;
        }
    }
}

